export default function Footer() {
  return (
    <footer
      style={{
        marginTop: "auto",
        padding: "32px 24px",
        borderTop: "1px solid var(--border-subtle)",
        textAlign: "center",
      }}
    >
      <p
        style={{
          margin: 0,
          fontSize: "0.8125rem",
          color: "var(--text-muted)",
          letterSpacing: "-0.01em",
        }}
      >
        SoundBench — Vocal Identity Analysis Platform
      </p>
    </footer>
  );
}
